export default {"src":"/_next/static/media/download-lock.92e99963.svg","height":12,"width":10,"blurWidth":0,"blurHeight":0};